type EnvType = 'development' | 'uat' | 'production';

const getEnv = (): EnvType => {
  if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_ENV) return 'development';
  return (process.env.REACT_APP_ENV || 'development') as EnvType;
};

const getApiUrl = (): string => {
  switch (getEnv()) {
    case 'uat':        return process.env.REACT_APP_API_URL_UAT  || '/api';
    case 'production': return process.env.REACT_APP_API_URL_PROD || '/api';
    default:           return process.env.REACT_APP_API_URL      || 'http://localhost:8080/api';
  }
};

export const envConfig = {
  apiUrl: getApiUrl(),
};

export default envConfig;
